import $ from 'jquery';
import { getCanvasBaseZoom } from '~loader/loader-utils';
import { getState, modifyState } from '~src/state';
import { centerCanvas } from './centerCanvas';

export const resetZoom = () => {
  const { width, height } = getState('options');
  const zoomValue = getCanvasBaseZoom(width, height);
  $('#canvas-zoom').css('transform', `scale(${zoomValue})`);

  // Update the current zoom state
  modifyState('currentCanvasZoom', zoomValue);

  centerCanvas();

  // Update spell check control sizes for all textboxes
  if (window.canvas) {
    window.canvas.getObjects().forEach((obj) => {
      if (obj.type === 'textbox' && obj.updateControlSizes) {
        obj.updateControlSizes();
      }
    });
  }
};
